import api from './api';
import { Product, Tag } from './product';
import { PaginatedResponse, CurrentMenu } from './typings';

const WAREHOUSE_URL = '/api/warehouse/';
export const CURRENT_WAREHOUSE_STORAGE_KEY = 'currentWarehouse';

export interface ProductStockInfo {
  id: number;
  quantity?: number;
  name: string;
  price: number;
  tagSlugs: Tag['slug'][];
  image?: string;
  allergens?: string;
  ingredients?: string;
  available_for_order?: boolean;
}

interface WithoutStockProduct
  extends Pick<Product, 'id' | 'name' | 'image' | 'allergens' | 'ingredients' | 'tags'> {
  price: number;
  applied_price: number;
  available_for_order: boolean;
}

interface InStockProduct extends WithoutStockProduct {
  articles_count: number;
  lot: {
    id: number;
    product: Product;
  };
}

export interface Warehouse {
  id: number;
  name: string;
  mds_type: string;
  menu: number;
  company: number;
  content_type: string;
  stocks: InStockProduct[];
  products_without_stock: WithoutStockProduct[];
  odoo_location_id: string;
}

export interface ProductAvailabilityChange {
  product_id: number;
  available: boolean;
}

export const findWarehouses = async (name: string): Promise<PaginatedResponse<Warehouse>> => {
  const response = await api({
    url: `${WAREHOUSE_URL}?page=1&ps=100&type=foodcounter&q=${name}`,
  });

  return response.data;
};

export const fetchCurrentMenu = async (warehouseId: number): Promise<CurrentMenu> => {
  const baseUrl = 'api/food_counter/current/';
  const response = await api({
    url: `${baseUrl}${warehouseId}`,
  });
  return response.data;
};

export const updateWarehouseProductAvailability = async (
  warehouseId: number,
  changes: ProductAvailabilityChange[],
): Promise<void> => {
  await api({
    url: `/api/food_counter/warehouse/${warehouseId}/`,
    method: 'PATCH',
    data: {
      products_without_stock: changes.map(e => {
        return { product: e.product_id, available_for_order: e.available };
      }),
    },
  });
};

export const storeCurrentWarehouse = (id: number, name: string) => {
  localStorage.setItem(CURRENT_WAREHOUSE_STORAGE_KEY, JSON.stringify({ id, name }));
};
